import { render, staticRenderFns } from "./TitleComponentForER.vue?vue&type=template&id=1733d670&scoped=true&"
import script from "./TitleComponentForER.vue?vue&type=script&lang=ts&"
export * from "./TitleComponentForER.vue?vue&type=script&lang=ts&"
import style0 from "./TitleComponentForER.vue?vue&type=style&index=0&id=1733d670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1733d670",
  null
  
)

export default component.exports